<template>
    <div class="w-full flex items-center bg-card border-y border-zinc-700 px-4 py-3 text-xs uppercase font-bold justify-center">
        <span class="text-red-500 text-center">{{ $t(segmentModes[settings.segment_mode]) }}</span>
        <span class="border-l border-zinc-700 pl-4 ml-4 text-center" v-if="settings.segment_mode == 0">{{ targetTypeLabel }}</span>
        <span class="border-l border-zinc-700 pl-4 ml-4 text-center" v-if="settings.segment_mode == 0">{{ hitsCountLabel }}</span>
        <span class="border-l border-zinc-700 pl-4 ml-4 text-center" v-if="settings.segment_mode == 1">{{ $t(pointsModes[settings.points_mode]) }}</span>
        <span class="border-l border-zinc-700 pl-4 ml-4 text-center">{{ $t(segmentOrder[settings.target_order]) }}</span>
    </div>
</template>

<script>
import { DART_TYPES } from '@/constants/dartTypes.js'
import { POINTS_MODES, SEGMENT_MODES, SEGMENT_ORDER } from '@/services/games/5_segments.ts'

export default {
    name: 'SegmentsSettingsBar',
    props: {
        settings: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            segmentModes: SEGMENT_MODES,
            segmentOrder: SEGMENT_ORDER,
            pointsModes: POINTS_MODES,
        }
    },
    computed: {
        hitsPerTarget() {
            return this.settings?.hits_per_target || 1
        },
        hitsCountLabel() {
            const key =
                this.hitsPerTarget === 1
                    ? 'match_settings.hits_count_singular'
                    : 'match_settings.hits_count_plural'
            return this.$t(key, { n: this.hitsPerTarget })
        },
        // Derive the throw mode from the configured targets rather than storing it
        // separately: a full ring (all 20 of one S/D/T type) reads as that ring,
        // anything else is a hand-picked custom selection.
        targetTypeLabel() {
            const targets = this.settings?.segments_to_hit || []
            const ringKeys = {
                [DART_TYPES.SINGLE]: 'match_settings.ring_singles',
                [DART_TYPES.DOUBLE]: 'match_settings.ring_doubles',
                [DART_TYPES.TRIPLE]: 'match_settings.ring_triples',
            }
            if (targets.length) {
                const firstType = targets[0].type
                const isFullRing =
                    targets.length === 20 &&
                    ringKeys[firstType] &&
                    targets.every((target) => target.type === firstType)
                if (isFullRing) {
                    return this.$t(ringKeys[firstType])
                }
            }
            return this.$t('match_settings.ring_custom')
        },
    },
}
</script>
